import React from 'react'
import { BookEventWrapper } from '../events/styles'
import Button from '../Button'
import { Header2 } from '../../styles/Components'
import { gsColors } from '../../styles/Variables'

const BookEvent = ({ handleClick }) => {
  return (
    <BookEventWrapper>
      <Header2 align="center">Ready to book a corporate event?</Header2>
      <Button large color={gsColors.sunsetOrange} onClick={handleClick}>
        Book A Corporate Event
      </Button>
    </BookEventWrapper>
  )
}

export default BookEvent
